;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();export type FreemiumTrialRemainingParts = {
	days: number;
	hours: number;
	minutes: number;
};

export function getFreemiumTrialRemainingParts({
	expiresAt,
	now = Date.now(),
}: {
	expiresAt: Date;
	now?: number;
}): FreemiumTrialRemainingParts | null {
	const remainingMs = expiresAt.getTime() - now;
	if (remainingMs <= 0) {
		return null;
	}

	const totalMinutes = Math.floor(remainingMs / 60_000);
	const days = Math.floor(totalMinutes / 1_440);
	const hours = Math.floor((totalMinutes % 1_440) / 60);
	const minutes = totalMinutes % 60;

	return { days, hours, minutes };
}

export function formatFreemiumTrialEndsInLabel({
	expiresAt,
	now = Date.now(),
}: {
	expiresAt: Date;
	now?: number;
}): string | null {
	const parts = getFreemiumTrialRemainingParts({ expiresAt, now });
	if (!parts) {
		return null;
	}

	if (parts.days > 0) {
		return parts.days === 1 ? "1 day" : `${parts.days} days`;
	}

	if (parts.hours > 0) {
		return parts.hours === 1 ? "1 hour" : `${parts.hours} hours`;
	}

	if (parts.minutes > 0) {
		return parts.minutes === 1 ? "1 minute" : `${parts.minutes} minutes`;
	}

	return "soon";
}
